import { ReviewCandidatePullFromJobBoardsModule } from './reviewCandidatePullFromJobBoards/review-candidate-pull-from-job-boards.module';
import { AssessmentsSyncMessageModule } from './assessmentsSyncMessage/assessments-sync-message.module';
export var ComponentsModule = angular.module('4do5.componentsModule', [
    ReviewCandidatePullFromJobBoardsModule,
    AssessmentsSyncMessageModule
])
    .name;
//# sourceMappingURL=components.module.js.map